<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section" v-show="FormInputs.Associations">
    <div class="my-account-title">Professional Association Information</div>
    <div class="account_login_info">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
          <label class="account_label">Professional Associations</label>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
          <ul class="association_info" v-if="AccountView.organizations">
            <li v-for="(value, key) in AccountView.organizations.list" v-if="value!='Other'">{{value}}</li>
            <li v-if="AccountView.organizations.others">{{AccountView.organizations.others}}</li>
          </ul>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130" v-on:click="EditSection()">Edit</button>
      </div>
    </div>

     <loading-component v-if="isLoading"></loading-component>
    <!--Edit Mode START-->
    <div v-if="isModalShown">
      <div class="modal-mask" role="dialog">
        <div class="overlay-mask">
          <div class="modal-dialog modal-lg">
            <div class="modal-content modal-edit-bg">
              <div class="modal-body">
                <div v-if="isFormLoading" class="row">
                  <page-loader></page-loader>
                </div>
                <div v-else>
                  <div class="close_btn" v-on:click="CloseModal()"></div><br>
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <edit-association-info :AccountEdit="AccountEdit" :FormInputs="FormInputs" :CheckboxBusiness="CheckboxBusiness"></edit-association-info>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10" v-on:click="SaveAccount()">Save </button>
                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10" v-on:click="CloseModal()">Cancel</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditAssociationInfo from "@/components/portal/userAccount/accountEdit/EditAssociationInfo";
import LoadingComponent from "@/components/shared/LoadingComponent";
import PageLoader from "@/components/shared/PageLoader";
export default {
  props: ['AccountView', 'AccountEdit', 'AccountValidationResult', 'CheckboxBusiness','FormInputs', "isFormLoading"],
  components: { EditAssociationInfo, LoadingComponent, PageLoader },
  data() {
    return {
      isModalShown: false,
      isLoading: false
    };
  },
  methods: {
    EditSection() {
      document.body.classList.add("body-overflow");
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    SaveAccount() {
      this.isLoading = true;
      axios
        .post("/Account/ProfessionalAssociationInformation", this.AccountEdit, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(response => {
          var _this = this;
          _this.isLoading = false;
          if (response.data.isSuccess == true) {
            _this.$emit("selfReload");
            _this.CloseModal();
            _this.$emit("success");
          } else {
            console.log("Error in Saving!");
          }
        })
        .catch(function(error) {
          console.log(error);
          _this.$router.push({name: 'Error'});
        });
    }
  }
}
</script>



// WEBPACK FOOTER //
// AssociationInfo.vue?78c78a2b